import { ReactNode } from 'react';
import clsx from 'clsx';

import { ProgressBar } from '@@/ProgressBar';

interface Props {
  value: number;
  total: number;
  /**
   * Rendered before the bar. Leave it out and use ResourceUsageItem instead
   * when the bar is a form field, so the label lines up with the other fields.
   */
  label?: ReactNode;
  annotation?: ReactNode;
  className?: string;
  labelClassName?: string;
  barClassName?: string;
}

/** How much of a resource is used, as a bar with its numbers beside it. */
export function ResourceUsageBar({
  value,
  total,
  label,
  annotation,
  className,
  labelClassName,
  barClassName,
}: Props) {
  return (
    <div className={clsx('mt-1 flex items-center gap-2', className)}>
      {label && (
        <span className={clsx('shrink-0 truncate text-xs', labelClassName)}>
          {label}
        </span>
      )}
      <ProgressBar
        steps={[{ value, className: 'progress-bar' }]}
        total={total}
        className={barClassName}
      />
      <div className="flex shrink-0 text-xs">{annotation}</div>
    </div>
  );
}
